import ManageCustomer from './manage-customer';

export default function ManageHelicopterServiceProvider() {
  return <ManageCustomer variant="heli-provider" />;
}
